<template>
  <card class="flex-wrap mbo-4" customClass="card-maturity-details">
    <template #header>
      <div class="flex-wrap header-maturity-details justify-content-between">
        <div class="d-flex" style="margin: auto 0">
          <div class="card-title">maturity details</div>
        </div>
        <div class="d-flex align-items-center">
          <!-- v-if="!settleAdd" -->
          <button
            class="btn btn-primary btn-vault-save"
            type="button"
            @click="postingSettle"
            v-if="tabState === 'SETTLEMENT' && !settleAdd"
            :disabled="loading"
          >
            settle
          </button>
          <button
            class="btn btn-primary btn-vault-save"
            type="button"
            @click="postingTransaction"
            v-if="tabState === 'ENT-TRANSC'"
            :disabled="loading"
          >
            save
          </button>
        </div>
      </div>
    </template>
    <div class="tab mbo-3">
      <div
        class="tab-item"
        :class="{ active: tabState === 'OVERVIEW' }"
        @click="tabState = 'OVERVIEW'"
      >
        Overview
      </div>
      <div
        class="tab-item"
        :class="{ active: tabState === 'SETTLEMENT' }"
        @click="tabState = 'SETTLEMENT'"
      >
        Settlement
      </div>
      <div
        class="tab-item"
        :class="{ active: tabState === 'ENT-TRANSC' }"
        @click="tabState = 'ENT-TRANSC'"
      >
        Enter transactions
      </div>
    </div>
    <div class="w-100" v-if="tabState === 'OVERVIEW'">
      <b-row no-gutters class="justify-content-between">
        <b-col cols="3" class="box-mature-value">
          <div class="text-head">contract settled</div>
          <div class="text-body">
            <div class="d-flex" style="gap: 12.5px" v-if="settleAdd">
              <span class="my-auto ml-auto" style="color: #27ae60">Yes</span>
              <img
                src="/icon/check-circle.svg"
                alt=""
                class="my-auto mr-auto"
              />
            </div>
            <div class="d-flex" style="gap: 12.5px" v-else>
              <span class="my-auto ml-auto" style="color: #ee6b6b">No</span>
              <img
                src="/icon/x-circle-red.svg"
                alt=""
                class="my-auto mr-auto"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="3" class="box-mature-value">
          <div class="text-head">vault value (USD)</div>
          <div class="text-body">
            {{ moneyFormat(vault_value) }}
          </div>
        </b-col>
        <b-col cols="3" class="box-mature-value">
          <div class="text-head">time since maturity</div>
          <div class="text-body">
            {{ time_since_maturity }}
          </div>
        </b-col>
        <b-col cols="3" class="box-mature-value">
          <div class="text-head">average premium</div>
          <div class="text-body">
            <span v-if="data.average_premium">
              {{ parseFloat(data.average_premium).toFixed(3) }}
            </span>
            <span v-else>0</span>
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters class="vault-detail-bar">
        <b-col cols="12" class="">
          <b-row no-gutters>
            <b-col cols="6" class="text-left">
              Premiums collected: {{ moneyFormat(premium_collected) }} USD
            </b-col>
            <b-col cols="6" class="text-right">
              Max: {{ moneyFormat(max_deposit) }} USD
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-progress
            :value="premium_collected"
            :max="max_deposit"
            class="mt-2 mb-2"
          ></b-progress>
        </b-col>
        <b-col cols="12" class="text-right">
          Volume left: {{ volume_left }} USD
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-3" style="row-gap: 24px">
        <b-col cols="3" class="box-list-data">
          <div class="text-head">deposits processed</div>
          <div class="text-body">{{ data.deposit_processed }}</div>
        </b-col>
        <b-col cols="3" class="box-list-data">
          <div class="text-head">total deposit amount (USD)</div>
          <div class="text-body">{{ total_deposit_amount }}</div>
        </b-col>
        <b-col cols="3" class="box-list-data">
          <div class="text-head">withdrawals processed</div>
          <div class="text-body">{{ data.withdrawal_processed }}</div>
        </b-col>
        <b-col cols="3" class="box-list-data">
          <div class="text-head">total withdrawal amount (USD)</div>
          <div class="text-body">{{ total_withdrawal_amount }}</div>
        </b-col>
      </b-row>
    </div>
    <div class="w-100" v-if="tabState === 'SETTLEMENT'">
      <b-row no-gutters class="mt-3 justify-content-between">
        <b-col cols="6" class="box-list-data colm-6">
          <div class="text-head">token price (USD)</div>
          <div class="text-body">
            <input
              type="number"
              class="input-settle"
              v-model="vault_token_price"
              placeholder=""
              aria-label=""
              aria-describedby=""
              :disabled="settleAdd"
            />
          </div>
        </b-col>
        <b-col cols="6" class="box-list-data colm-6">
          <div class="text-head">Penalty / reward (USD)</div>
          <div class="text-body">
            <input
              type="number"
              class="input-settle"
              v-model="vault_penalty_reward"
              placeholder=""
              aria-label=""
              aria-describedby=""
              :disabled="settleAdd"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="w-100" v-if="tabState === 'ENT-TRANSC'">
      <b-row no-gutters class="mt-3 justify-content-between">
        <b-col cols="4" class="box-list-data colm-4">
          <div class="text-head">Premium charged (USD)</div>
          <div class="text-body">
            <input
              type="number"
              class="input-settle"
              v-model="premium_charge"
              placeholder=""
              aria-label=""
              aria-describedby=""
            />
          </div>
        </b-col>
        <b-col cols="4" class="box-list-data colm-4">
          <div class="text-head">strike price (USD)</div>
          <div class="text-body">
            <input
              type="number"
              class="input-settle"
              v-model="strike_price"
              placeholder=""
              aria-label=""
              aria-describedby=""
            />
          </div>
        </b-col>
        <b-col cols="4" class="box-list-data colm-4">
          <div class="text-head">total volume of tokens</div>
          <div class="text-body">
            <input
              type="number"
              class="input-settle"
              v-model="volume_token"
              placeholder=""
              aria-label=""
              aria-describedby=""
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </card>
</template>

<script>
import Card from "../Card.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      settleAdd: false,
      tabState: "OVERVIEW",
      amount: 25,
      premium_collected: null,
      //   max_deposit: 100,
      vault_token_price: null,
      vault_penalty_reward: 100000,
      loading: false,
      premium_charge: null,
      strike_price: null,
      volume_token: null,
    };
  },
  components: {
    Card,
  },
  mounted() {
    this.init();
  },
  computed: {
    vault_value() {
      if (this.data.vault_detail) {
        if (this.data.type == "put_selling") {
          return parseFloat(
            parseFloat(this.data.vault_detail.total_vault_value)
          );
        } else {
          return parseFloat(
            parseFloat(this.data.vault_detail.total_vault_value) *
              parseFloat(this.data.price)
          );
        }
      } else return 0;
    },
    is_premium_completed() {
      if (this.premium_collected >= this.max_deposit) return true;
      else return false;
    },
    volume_left() {
      if (this.max_deposit >= this.premium_collected) {
        return this.moneyFormat(this.max_deposit - this.premium_collected);
      } else return 0;
    },
    total_deposit_amount() {
      if (this.data.total_deposit_amount) {
        if (this.data.type == "put_selling") {
          return this.moneyFormat(this.data.total_deposit_amount);
        } else {
          return this.moneyFormat(
            this.data.total_deposit_amount * this.data.price
          );
        }
      } else return 0;
    },
    total_withdrawal_amount() {
      if (this.data.total_withdrawal_amount) {
        if (this.data.type == "put_selling") {
          return this.moneyFormat(this.data.total_withdrawal_amount);
        } else {
          return this.moneyFormat(
            this.data.total_withdrawal_amount * this.data.price
          );
        }
      } else return 0;
    },
    time_since_maturity() {
      if (this.data.vault_detail) {
        return this.data.vault_detail.time_since_maturity;
      } else return "-";
    },
    max_deposit() {
      if (this.data.type == "put_selling") {
        return parseFloat(this.data.max_deposit);
      } else {
        return parseFloat(this.data.max_deposit * this.data.price);
      }
    },
  },
  methods: {
    init() {
      //
      this.settleAdd = false;
      if (this.data.maturity_detail) {
        this.vault_token_price = this.data.maturity_detail.vault_token_price;
        this.vault_penalty_reward =
          this.data.maturity_detail.vault_penalty_reward;
        if (this.data.maturity_detail.contract_settled === "yes") {
          this.settleAdd = true;
        }
      }
      this.premium_collected = this.data.premium_collected ?? 0;
    },
    postingSettle() {
      this.loading = true;
      this.$store
        .dispatch("API", {
          url: "/api/settlement",
          method: "post",
          vaults_id: this.$route.params.id,
          vault_token_price: this.vault_token_price,
          vault_penalty_reward: this.vault_penalty_reward,
        })
        .then((result) => {
          this.$store
            .dispatch("vault_detail/fetchVault", this.$route.params.id)
            .then((result) => {
              this.init();
            });
        })
        .finally(() => (this.loading = false));
    },
    postingTransaction() {
      const date = `${new Date().getFullYear()}-${
        new Date().getMonth() + 1
      }-${new Date().getDate()}`;
      this.loading = true;

      this.$store
        .dispatch("API", {
          url: "/api/transaction",
          method: "post",
          vaults_id: this.$route.params.id,
          date: date,
          action: "transaction",
          //   wallet_address: "-",
          premium_charge: this.premium_charge,
          strike_price: this.strike_price,
          volume_token: this.volume_token,
          amount: this.premium_charge,
          currency: "USD",
          state:
            this.data.vaults_type == "matured" ? "matured" : this.data.state,
        })
        .then((result) => {
          this.$store
            .dispatch("vault_detail/fetchVault", this.$route.params.id)
            .then((result) => {
              this.init();
            });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.card-maturity-details {
  border: 1px solid #27ae60 !important;
  border-radius: 4px !important;
  background: $primary-4;
  .header-maturity-details {
    border-bottom: 1px solid #eaedf0;
    padding-bottom: 13px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    height: 48.25px;
  }
  .card-title {
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
    //letter-spacing: 0.04em;
    text-transform: uppercase;
    color: $primary-5;
    margin: auto 0;
  }
  .vault-detail-bar {
    font-family: Exo;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #222222;
    margin-bottom: 39px;
    margin-top: 40px;
  }
  .box-mature-value {
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 15px 6.25px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    border: 1px solid #eaedf0;
    box-sizing: border-box;
    border-radius: 4px;
    flex: 0 0 24% !important;
    .text-head {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: center;
    }
    .text-body {
      font-weight: bold;
      font-size: 36px;
      line-height: 48px;
      text-align: center;
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
  }
  .box-list-data {
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 4px 10px 8px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    &.colm-6 {
      flex: 0 0 48.5% !important;
    }
    &.colm-4 {
      flex: 0 0 32% !important;
    }
    .text-head {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: left;
    }
    .text-body {
      font-weight: 900;
      font-size: 16px;
      line-height: 18px;
      text-align: left;
      text-transform: capitalize;
    }
  }
  .progress {
    height: 10px;
    background: #c0c0c0 !important;
    mix-blend-mode: normal;
    box-shadow: inset 1.85px 1.85px 7.4px rgba(0, 0, 0, 0.25),
      inset 1.85px 1.85px 3.7px rgba(0, 0, 0, 0.25);
    border-radius: 1.85px;
    .progress-bar {
      background: #27ae60 !important;
      opacity: 0.8;
      border-radius: 1.85px;
    }
  }
  .btn-vault-save {
    width: 136px;
    height: 34px;
    border-radius: 4px !important;
    font-family: Exo !important;
    font-weight: bold !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase;
    background: #27ae60 !important;
    &.edit {
      color: #27ae60 !important;
      background: $primary-4 !important;
      border: 1px solid #27ae60 !important;
    }
  }
  .tab {
    display: flex;
    .tab-item {
      cursor: pointer;
      width: 190px;
      font-family: Exo;
      font-weight: normal;
      // font-size: 0.97222vw;
      // line-height: 0.97222vw;
      font-size: 14px;
      line-height: 140%;
      text-align: center;
      text-transform: capitalize;
      color: #222222;
      margin: auto;
      padding: 12px 0;
      &.active {
        font-weight: bold;
        border-bottom: 3px solid #27ae60;
      }
    }
  }
  .input-settle {
    width: 100%;
    font-family: Exo;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    text-transform: capitalize;
    color: #222222;
    padding: 10px 30px 10px 8px;
    border: 1px solid #b9b9b9;
    box-sizing: border-box;
    border-radius: 4px;
    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #222222;
      opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #222222;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #222222;
    }
    &:disabled {
      color: #8c8c8c;
    }
  }
}
</style>
